
 console.log("before pressing");
document.getElementById('newsletter-submit-1494292487693').addEventListener('click', function(e) {
    e.preventDefault();
    var email_value = document.querySelector('input[id="Email-1494292487693').value;
    window.location.href = "https://agentshop.no/a/loyalty?email=" + encodeURIComponent(email_value);
 
});


if (window.location.href.indexOf("/loyalty") !== -1) {
var urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.has('email')) {
        var email = urlParams.get('email');
        
        console.log('Email:', email);
        
        // You can use the email value as needed, for example:
        $("#email").val(email);
        // alert("Email: " + email); // Display an alert with the email value
    } else {
        console.log('Email parameter not found in the URL.');
    }
}

document.getElementById('newsletter-form-submit-template--16654183399591__newsletter_rhp9aN').addEventListener('click', function(e) {
    e.preventDefault();
    var email_value = document.querySelector('input[id="Email-template--16654183399591__newsletter_rhp9aN').value;
    window.location.href = "https://agentshop.no/a/loyalty?email=" + encodeURIComponent(email_value);
});





